import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const ImageWrapperContainer = styled.div`
  /* height: 200px; */
  width: 100%;
  padding-top: 75%; /* 4:3 Aspect Ratio (divide 3 by 4 = 0.75) */
  position: relative;
  ${mediaQuery('medium')} {
    padding-top: 37.5%;
    width: 50%;
  }
  ${mediaQuery('phone')} {
    padding-top: 75%;
    width: 100%;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

